module.exports = __webpack_public_path__ + "img/arrow-left.74a44206.svg";